
import {
    SELECTION_OPERATION_ACTION_TYPE
} from '../sagas/selection';

import {
    GET_PROJECT_ACTION_TYPE,
    REFRESH_PROJECT_ACTION_TYPE
} from '../sagas/project';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState,
    count: 0,
    vymera: 0
};

export function getSelection(state) {
    return {
        count: state.count,
        vymera: state.vymera
    };
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(SELECTION_OPERATION_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case SELECTION_OPERATION_ACTION_TYPE.SUCCESS:
                return {
                    ...loaderReducer(state, action),
                    count: parseInt(action.data.result.selection.count),
                    vymera: parseInt(action.data.result.selection.vymera)
                };

            case REFRESH_PROJECT_ACTION_TYPE:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.DEFAULT:
                return {
                    ...initialState
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
